import React, {useEffect, useState} from "react";

import InputSelect from "../InputSelect/InputSelect";
import InputText from "../InputText/InputText";
import CheckBox from "../CheckBox/CheckBox"
import Alert from "../Alert/Alert";
import { validateForm } from "../../Helpers/Validade";
import { api, geocodeServices } from "./../../Api/api"

import "./Styles.css";

const ModalColabora = ({close, visible}) => {
    const [modalVisible, setModalVisible] = useState(false)

    const [alert, setAlert] = useState(false)
    const [msgAlert, setMsgAlert] = useState('')

    const [stateSend, setStateSend] = useState(false)
    const [sendSuccess, setSendSuccess] = useState(false)

    const [payloadCep, setPayloadCep] = useState('');

    const [errorForm, setErrorForm] = useState(true)

    useEffect(() => {
        setModalVisible(visible)
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [visible])

    const handleValidateForm = () => validateForm(document.getElementById('modal-colabora'), setErrorForm)

    const sendForm = async (event) => {
        event.preventDefault();

		const validate = validateForm(event, setErrorForm ,true)
		if (validate.error) return

        var value = validate.value

        try {
            setStateSend(true)
            let save = Object.assign(value, payloadCep)            
            let {data} = await api.post("/problema/colaborar", save);

            if(data.addResults[0].success){
                setMsgAlert("Obrigado por colaborar com a TIM");
                setAlert(true);
                setSendSuccess(true)

                // Google Tag Manager
                // eslint-disable-next-line no-undef
                dataLayer.push({ 
                    event:"formulário-portas-abertas", 
                    fluxo: "portais-porta-abertas",
                    form: "colabore-com-a-melhoria", 
                    botao: "enviar-colaboracao"    
                });

            }else{
                setMsgAlert("Não foi possivel salvar as informações.");
                setAlert(true);
                setSendSuccess(false)
            }

        } catch (error) {
            console.log(error)
            setMsgAlert("Não foi possivel salvar as informações.");
            setAlert(true);
        }finally{
            setStateSend(false)
        }
    }

    const formatCep = (e) => {
        let target = e.target
        let value = target.value

        const badchars = /[^\d]/g
        const mask = /(\d{5})(\d{3})/
        const cep = new String(value).replace(badchars, "");

        target.value = cep.replace(mask, "$1-$2")

        if (value.replace("-", '').length > 7){
            try {
                geocodeServices.get(`/findAddressCandidates?Postal=${value}&outFields=*&f=pjson&countryCode=BR&langCode=pt-br`).then((location) => {
                    geocodeServices.get(`/reverseGeocode?f=pjson&featureTypes=&location=${location.data.candidates[0].location.x},${location.data.candidates[0].location.y}`).then((geocode) => {
                        let infoLocal = {
                            cep: value.replace("-", ''),
                            endereco: geocode.data.address.Address,
                            bairro: geocode.data.address.District,
                            cidade: geocode.data.address.City,
                            estado: geocode.data.address.RegionAbbr,
                            x: location.data.candidates[0].location.x,
                            y: location.data.candidates[0].location.y
                        }

                        setPayloadCep(infoLocal);
                    })
                });
                
            } catch (error) { 
                console.log(error)
            }
        }
    }

    const formatTel = (e) => {
        let target = e.target
        let value = target.value

        const badchars = /[^\d]/g
        const mask = /(\d{2})(\d{5})(\d{4})/
        const tel = new String(value).replace(badchars, "");

        target.value = tel.replace(mask, "($1) $2-$3");
    }

    const problema = [
        {
            id: 1,
            value: 'Não completa ligação'
        },
        {
            id: 2,
            value: 'Queda de ligação'
        },
        {
            id: 3,
            value: 'Baixa qualidade na ligação'
        },
        {
            id: 4,
            value: 'Ausência de sinal'
        },
        {
            id: 5,
            value: 'Ausência de conexão de dados'
        },
        {
            id: 6,
            value: 'Quedas na conexão de dados'
        },
        {
            id: 7,
            value: 'Sinal fraco'
        },
    ]

    const onde = [
        {
            id: 1,
            value: 'Ambiente interno'
        },
        {
            id: 2,
            value: 'Ambiente externo'
        },
        {
            id: 3,
            value: 'Em minha casa'
        },
        {
            id: 4,
            value: 'Em movimento'
        },
    ]

    const frequencia = [
        {
            id: 1,
            value: 'Pontual'
        },
        {
            id: 2,
            value: 'Permanente'
        }
    ]

    const closeAlert = () => {
        setAlert(false)

        if(sendSuccess){
            let closeModal = document.getElementById("close-modal-colabora")
            closeModal.click()
        }
    }

    return (
        <React.Fragment>
            {   !modalVisible ? null :
                <div id="modal-colabora" className="modal-colabora">
                    <Alert visible={alert} close={closeAlert} msg={msgAlert} />
                    <div className="modal-conteudo">
                        <div className="container-topo">
                            <div className="logo-tim"></div>
                            <div className="close" id="close-modal-colabora" onClick={close}></div>
                        </div>
                        <div className="container-lista">
                            <span className="titulo-modal">Colabore com a melhoria do serviço</span>
                            <span className="msg-agradecimento-tim">Obrigado por colaborar com a TIM</span>
                            <form className="form-colabore" onSubmit={sendForm}>
                                <InputText name={'cep'} type={"text"} label={"CEP"} placeholder="00000-000" styleInput="input-colabora" styleLabel="label-colabora" containerStyle="container-input-colabora" data-required={true} onKeyUp={formatCep} onBlur={handleValidateForm} />
                                <InputSelect name={'tipo'} typeOption="Object" options={problema} label={"Selecione o que ocorreu"} msgOption={"O que houve?"} data-required={true} onChange={handleValidateForm} />
                                <InputSelect name={'local'} typeOption="Object" options={onde} label={"Selecione onde aconteceu"} msgOption={"Onde ocorreu?"} data-required={true} onChange={handleValidateForm} />
                                <InputSelect name={'frequencia'} typeOption="Object" options={frequencia} label={"Selecione a frequência"} msgOption={"Com que frequência?"} data-required={true} onChange={handleValidateForm} />
                                <InputText name={'nome'} type={"text"} label={"Digite seu nome"} styleInput="input-colabora" styleLabel="label-colabora" containerStyle="container-input-colabora" data-required={true} onBlur={handleValidateForm} />
                                <InputText name={'telefone'} type={"text"} label={"Telefone"} placeholder="(XX) 00000-0000" styleInput="input-colabora" styleLabel="label-colabora" containerStyle="container-input-colabora" data-required={true} onKeyUp={formatTel} onBlur={handleValidateForm} />
                                <InputText name={'email'} type={"email"} label={"E-mail"} styleInput="input-colabora" styleLabel="label-colabora" containerStyle="container-input-colabora" data-required={true} onBlur={handleValidateForm} />
                                <CheckBox name={'notificacaoemail'} label={"Tenho interesse em receber futuramente alertas por notificação no meu e-mail."} />
                                <CheckBox name={'notificacaocelular'} label={"Tenho interesse em receber futuramente alertas por notificação no meu celular."} />
                                <button className={`button-colaboracao ${errorForm ? '' : 'button-active'}`}>{!stateSend ? "Enviar colaboração" : 'Enviando...'}</button>
                            </form>
                            <div className="informativo-colabora">
                                <span>
                                    Suas informações são importantes para a melhoria dos nossos serviços. Com os dados enviados, podemos trabalhar para oferecer cada vez mais qualidade para você. Se precisar de um atendimento direcionado à sua consulta, entre em contato conosco através do nosso canal Fale com a TIM
                                </span>
                                <span>
                                    A TIM realiza também constantes atividades de manutenção e otimização, buscando melhor serviço para você. Para mais informações sobre a região, digite o seu endereço no Mapa de Cobertura
                                </span>
                                <span>
                                    E lembre-se: a qualidade do sinal em locais fechados pode ser influenciada por fatores externos
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </React.Fragment>
    )
}

export default ModalColabora